import { ComponentConfig } from '@measured/puck';

type SpacerBlockProps = {
  height: number;
};

const SpacerBlock: ComponentConfig<SpacerBlockProps> = {
  label: 'Spacer',
  fields: {
    height: {
      type: 'number',
      label: 'Spacing Height (px)',
      min: 0,
      step: 1,
    },
  },
  defaultProps: {
    height: 20,
  },
  render: ({ height }: SpacerBlockProps) => {
    return <div style={{ height: `${height}px`, width: '100%' }} />;
  },
};

export { SpacerBlock };
